export const PUBLISHER_FIELD_LABELS: Record<string, string> = {
    name: 'Name',
    sellerAccountId: 'SellerAccountId',
    language: 'Language',
    iabCategoriesIds: 'Publisher IAB Categories',
    dspBlackListIds: 'Dsp blacklist',
    maxQps: 'QPS',
    blackListDomainsField: 'Filter Mode',
    blackListDomains: 'Filter Mode',
    domains: 'Allowed Domains',
    allDomains: 'Allowed Domains',
    domainCategories: 'Allowed Domains',
    acceptAllDomains: 'Accept All Domains',
    includeDomains: 'Include Allowed Domains in sellers.JSON',
    mobileAppIds: 'Allowed Mobile App IDs',
    allMobileAppIds: 'Allowed Mobile App IDs',
    acceptAllMobileAppIds: 'Accept All Mobile App IDs',
    dspFeeNames: 'DSP Fee',
    winNotification: 'Win notification',
    bundle: 'Bundle',
    storeUrl: 'Store URL',
    auctionMode: 'Auction Mode',
    houseBidderMode: 'House Bidder Mode',
    fee: 'Alkimi Exchange Fee',
    sellerDomain: 'Seller Domain',
    sellerType: 'Seller Type',
    revenueCalculationMethod: 'Revenue Calculation Method',
    passThrough: 'Pass Through',
    useParentSellerAccountId: 'Use Parent Seller Id',
    parentPublisherId: 'Parent Publisher',
    validation: 'Validation',
    publicValidationKey: 'Public validation key',
    email: 'Email',
    timezoneId: 'Time Zone',
    test: 'Restrict Blockchain Transaction',
    athenaValidationsLimit: 'Validations limit',
    athenaPeriodLimit: 'Request/Response Id period limit',
    countries: 'Countries',
    active: 'Active',
    status: 'Status',
    publisherDomain: 'Publisher domain',
    adfiEligible: 'AdFI Eligible',
    adFiEnabled: 'AdFI Eligible',
    adfiFeePercent: 'AdFI Fee %',
    adFiFee: 'AdFI Fee %',
    serviceFeePercent: 'Service Fee %',
    serviceFee: 'Service Fee %',
    publisherLegalName: 'Publisher Legal Name',
    publisherRegisteredAddress: 'Publisher Registered Address',
    publisherContactEmail: 'Publisher Contact Email',
    currencyPreference: 'Currency Preference',
    vatRate: 'VAT Rate',
    vatRegistrationNumber: 'VAT Registration Number',
    bankAccountName: 'Bank Account Name',
    bankAccountType: 'Bank Account Type',
    bankAccountNumber: 'Bank Account Number',
    sortCode: 'Sort Code',
    iban: 'IBAN',
    swiftBicCode: 'Swift / BIC Code',
    routingNumber: 'Routing Number',
    paymentTermsDays: 'Payment Terms (Days)',
    dspBlackListNames:'Dsp blacklist',
    countryCodes:'Countries',
    token:'Token',
}

export const DSP_FIELD_LABELS: Record<string, string> = {
    name: 'Name',
    endpointUrl: 'Endpoint URL',
    dspType: 'DSP Type',
    tmax: 'Timeout',
    maxQps: 'QPS',
    gzipCompression: 'Gzip compression',
    miniExchange: 'Mini Exchange',
    fee: 'DSP Fee',
    dspFee: 'DSP Fee',
    winNotification: 'Win notification',
    userSyncEndpoint: 'Cookie sync URL',
    userSyncUidMacro: 'Cookie sync UID macro',
    allDomains: 'Allowed Domains',
    domainCategories: 'Allowed Domains',
    acceptAllDomains: 'Accept All Domains',
    mobileAppIds: 'Allowed Mobile App IDs',
    allMobileAppIds: 'Allowed Mobile App IDs',
    acceptAllMobileAppIds: 'Accept All Mobile App IDs',
    dspFeeNames: 'DSP Fee',
    environment: 'Environment',
    environmentType: 'Environment',
    targetCountries: 'Countries',
    allowedIabCategoryCodes: 'IAB Categories',
    validation: 'Validation',
    publicValidationKey: 'Public validation key',
    active: 'Active',
    email: 'Email',
    timezoneId: 'Time Zone',
    countries: 'Countries',
    athenaValidationsLimit: 'Validations limit',
    athenaPeriodLimit: 'Request/Response Id period limit',
    UK: 'UK Cluster',
    US_WEST: 'US West Cluster',
    US_EAST: 'US East Cluster',
    targetDeviceTypes: 'Device Targeting',
    targetOperatingSystems: 'OS Targeting',
}

export const DEAL_FIELD_LABELS: Record<string, string> = {
    dealId: 'Deal ID',
    publisherIds: 'Publishers',
    publisherId: 'Publishers',
    publisherNames: 'Publishers',
    name: 'Name',
    dealType: 'Deal Type',
    startDate: 'Start Date',
    endDate: 'End Date',
    dealStatus: 'Deal Status',
    wseat: 'WSeats',
    adUnitId: 'Ad Unit IDs',
    geoRegion: 'Geo Countries',
    adFormat: 'Ad Formats',
    deviceType: 'Device Types',
    adSize: 'Ad Sizes',
    iabCategories: 'IAB Categories',
    fixedCpm: 'Fixed CPM',
    fallbackToOpenAuction: 'Fall Back to Open Auction',
    bidFloor: 'Bid Floor Price',
    bidIncrement: 'Bid Increment',
    volumeCommitment: 'Volume Commitment',
    deliveryGuarantee: 'Delivery Guarantee',
    allDomains: 'Allowed Domains',
    domainCategories: 'Allowed Domains',
    acceptAllDomains: 'Accept All Domains',
    mobileAppIds: 'Allowed Mobile App IDs',
    allMobileAppIds: 'Allowed Mobile App IDs',
    acceptAllMobileAppIds: 'Accept All Mobile App IDs',
    environment: 'Environment',
    environmentType: 'Environment',
    iabCategoryNames: 'IAB Categories',
    deviceTypeNames: 'Device Types',
    countryCodes: 'Geo Countries',
    adFormatNames: 'Ad Formats',
    adSizeNames: 'Ad Sizes',
    firstLookWindow: 'First Look Window',
}

export const PUBLISHER_EXCLUDED_FIELDS = ['athenaPeriodLeft', 'athenaValidationsLeft'] as const;

export const DSP_EXCLUDED_FIELDS = ['athenaPeriodLeft', 'athenaValidationsLeft'] as const;

export const DEAL_EXCLUDED_FIELDS = ['dealTypeConfiguration'] as const;